@import "../../global/temporary-mercury-overrides/_tab.scss";

:host {
  display: grid;
  block-size: 100%;
  grid-template-areas:
    "header header"
    "main aside";
  grid-template-rows: max-content 1fr;
  grid-template-columns: 1fr 280px;
  row-gap: var(--spacing-gap-l);
}

.section {
  display: contents;
}

// header
.header {
  display: grid;
  grid-area: header;
  grid-template-areas: "plugin-icon plugin-details";
  grid-template-columns: 64px 1fr;
  column-gap: var(--spacing-gap-xl);
  padding-block-start: var(--spacing-padding-xxl);
  padding-block-end: var(--spacing-padding-xl);
  padding-inline: var(--spacing-padding-xxl);
}
.plugin__icon {
  grid-area: plugin-icon;
  inline-size: 100%;
  block-size: auto;
  display: block;
}
.plugin__details {
  grid-area: plugin-details;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-gap-m);
}
.plugin__publisher {
  display: flex;
  align-items: center;
  gap: var(--spacing-gap-xs);
}
.plugin__description {
  line-height: var(--line-height-spacious); // WA: Text appears too tight.
}
.plugin__actions-container {
  margin-block-start: var(--spacing-padding-m);
  align-items: center;
  // Reserve the taller progress-bar height (control + gap + bar) so swapping
  // the install button for the progress bar doesn't shift the layout.
  min-block-size: calc(var(--control-block-size) + var(--spacing-gap-xs) + 4px);
}
.action-button {
  min-inline-size: 100px;

  &.more-versions-available {
    border-start-end-radius: 0 !important;
    border-end-end-radius: 0 !important;
  }
}
.installed-container {
  display: flex;
  align-items: center;
  gap: var(--spacing-gap-m);

  // WA Biggest Mercury icon (icon-s) looks small in this case.
  // Mercury should expose more icon sizes.
  ch-image {
    --ch-image-size: 20px;
  }
}

// main
.main {
  grid-area: main;
}
.docsTab {
  block-size: 100%;
}

// aside
.aside {
  grid-area: aside;
  overflow: auto;
  border-block-start: 1px solid var(--items-container__border-color);
}
.fields__list {
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: var(--font-size-body-s);
}
.plugin__info-category {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-gap-m);

  &:not(:first-child) {
    padding-block-start: var(--spacing-padding-xl);
    margin-block-start: var(--spacing-padding-xl);
    border-block-start: 1px solid var(--color-border-surface-on-elevation-1);
  }
}
.fields__list:not(.fields__list--as-tags) {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-gap-m);
  .field__li {
    display: flex;
    gap: var(--spacing-gap-xl);
  }
}
.fields__list--as-tags {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-gap-m);

  .field__li {
    border: 1px solid var(--color-border-surface-on-elevation-1);
    padding-block: var(--spacing-padding-xxs);
    padding-inline: var(--spacing-padding-m);
    border-radius: 4px;

    text-transform: lowercase;
  }
  .field__link {
    color: var(--color-text-neutral-strawberry);

    &:hover {
      color: var(--color-accent-primary-default);
    }
    &:active {
      color: var(--color-accent-primary-hover);
    }
  }
}

.field__name,
.field__value {
  flex: 1;
}
// WA: Link styles should be defined Mercury
.field__link {
  color: var(--color-accent-primary-default);
  &:hover {
    color: var(--color-accent-primary-hover);
  }
  &:active {
    color: var(--color-accent-primary-pressed);
  }
}
// WA: Remove tab elevation background color
.docsTab {
  background-color: transparent !important;
}

// WA: Styles for "button-icon-only" should be defined on mercury
.dropdown.button-icon-only::part(expandable-button) {
  padding: calc(
    (var(--control-block-size) - 2 * var(--control-border-width) - 16px) / 2
  ) !important;
  border-start-start-radius: 0 !important;
  border-end-start-radius: 0 !important;
}

.version-buttons-container {
  display: flex;
  align-items: stretch;
  gap: 1px;
}

.install-progress {
  flex: 1;
  min-inline-size: 220px;
}

ch-markdown-viewer {
  block-size: 100%;
  overflow: auto;
}

// WA: Need text with underline. This should be defined on Mercury
.text-underline {
  text-decoration: underline;
}
